/** ANSI escape codes for styling console output. Use these codes to style terminal output with colors and bold text. */
export enum LogStyle {
  Reset = '\x1b[0m',
  Bold = '\x1b[1m',
  Red = '\x1b[31m',
  Green = '\x1b[32m',
  Yellow = '\x1b[33m',
  Blue = '\x1b[34m',
  White = '\x1b[37m'
}
